module.exports = __webpack_public_path__ + "media/src/images/icons/magnifying_glass_color-776ac6c00f532ee79050c85bbf7cb98f.svg";